import { arrToObj } from "fp-helpers-nba";
import ScheduledMatches from "./../data/ScheduledMatches.json";

export const matches = ScheduledMatches;
export const matchesByID = arrToObj(ScheduledMatches, "gameId", true);
